import * as React from 'react';
import { cn } from '@/lib/utils';

export function PageToolbar({ children, className }) {
  return (
    <div className={cn(
      'sticky top-0 z-10 -mx-6 px-6 py-3 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-y mb-6',
      className
    )}>
      <div className="flex items-center gap-2">
        {children}
      </div>
    </div>
  );
}

export function FilterChip({ active, onClick, children, className }) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200',
        active
          ? 'bg-primary text-primary-foreground shadow-sm'
          : 'bg-muted text-muted-foreground hover:bg-muted/80',
        className
      )}
    >
      {children}
    </button>
  );
}